import { useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { LineChartComponent } from './index';
import { CustomDropdown } from '../../ui-elements/customDropdown/CustomDropdown';
import { Heading, InfoPanel, TypographyColor, TypographyType } from '../../ui-elements';
import * as Constants from '../../utils/constants/Constants';
import { geoState, selectedCategoryState, selecteddropDownDataLocationState, selPOICategories } from '../../states';

interface GrowthInTimeChartProps {
    headerText: string,
    infoText: string,
    data: any,
    color: string,
    breakDownType: string,
    setSelectedYear: (selectedYear: string) => void,
    selectedYear: string,

}

export const GrowthInTimeLocationLineChart = ({ headerText, infoText, data, color, breakDownType, selectedYear, setSelectedYear }: GrowthInTimeChartProps) => {


    // const [selectedDropDownData, setSelectedDropDownData] = useState('');
    const [selectedDropDownDataLocation, setSelectedDropDownDataLocation] = useRecoilState(selecteddropDownDataLocationState);
    const [selectedDataIndex, setSelectedDataIndex] = useState(0);
    const [lineChartData, setLineChartData] = useState<any[]>([]);
    const selectedCategory = useRecoilValue(selectedCategoryState);
    const selectedGeo = useRecoilValue(geoState);
    const prevGeoCode = useRef(selectedGeo);
    const [dropDownData, setDropDownData] = useState(data);
    const prevHeadertext = useRef(headerText);
    const [selCategoryList, setSelCategoryList] = useRecoilState(selPOICategories);
    const prevSelCategoryList = useRef(selCategoryList);

    useEffect(() => {
        setLineChartData(data);
    }, [data]);


    // useEffect(() => {
    //     if (headerText !== "Sub District" && headerText !== "Pin Code") {
    //         // Filter data for single line
    //         const filteredData = data.filter(
    //             (category: any) => category.name === "Average" || category.name === selectedDropDownDataLocation
    //         );
    //         setLineChartData(filteredData);
    //     } else {
    //         // Reset to all lines
    //         setLineChartData(data);
    //     }
    // }, [selectedDropDownDataLocation]);

    const handleChangeData = (value: any) => {
        // const value = e.target.value;
        setSelectedDropDownDataLocation(value);
    };

    useEffect(() => {
        const index = lineChartData.filter((item: any) => item.name !== 'Average').findIndex(
            (item: any) => item.name.toString().trim() === selectedDropDownDataLocation.toString().trim()
        );
        setSelectedDataIndex(index !== -1 ? index : 0); // Default to 0 if not found
    }, [selectedDropDownDataLocation, lineChartData]);

    const handleyearChange = (year: string) => {
        setSelectedYear(year); // Update the selected year when clicked
    };


    useEffect(() => {
        if (prevGeoCode.current !== selectedGeo) {
            // Category changed, reset to first item
            setDropDownData(data);
            setSelectedDropDownDataLocation('');
            prevGeoCode.current = selectedGeo;
        }
    }, [selectedGeo, data]);


    useEffect(() => {
        if (prevSelCategoryList.current !== selCategoryList) {
            // Category changed, reset to first item
            setDropDownData(data);
            setSelectedDropDownDataLocation('');
            prevSelCategoryList.current = selCategoryList;
        }

    }, [selCategoryList, data]);


    useEffect(() => {
        if (selectedDropDownDataLocation === '') {
            setDropDownData(data);
            setSelectedDropDownDataLocation(data?.[0]?.name || '');
        }
    }, []);

    useEffect(() => {
        if (prevHeadertext.current !== headerText) {
            setDropDownData(data);
            setSelectedDropDownDataLocation(data?.[0]?.name || '');
            prevHeadertext.current = headerText;
        }
    }, [headerText]);

    return (
        <div style={{ height: '', width: '100%', display: 'flex', flexDirection: 'column' }} className='margin-bottom-2'>
            <div
                className='w-100 d-flex flex-row justify-content-between align-items-center margin-top-bottom-4'
            >
                <div className="d-flex flex-row justify-content-start align-items-center height-4vh pt-2">
                    <Heading
                        title={`Growth of Pols over time for ${headerText}`}
                        type={TypographyType.h5}
                        colour={TypographyColor.secondary}
                        classname='text-start'
                    />
                    <InfoPanel text={infoText} classname='margin-left-2 fs-14 color-black-7' />
                </div>
                <div
                    className="margin-top-3 height-4vh w-50 d-flex flex-row justify-content-end"
                >
                    <div
                        style={{ borderRadius: '0.407vh', }}
                        className="border margin-bottom-2 w-25 height-4vh d-flex flex-row justify-content-between align-items-center margin-right-2"
                    >
                        {Constants.yearHeader.map((item) => (
                            <Heading
                                title={`${item}${item === "1" ? "Yr" : "Yrs"}`}
                                type={TypographyType.h5}
                                colour={TypographyColor.primary}
                                classname={`margin-left-2 margin-right-2 height-4vh d-flex align-items-center ${selectedYear === item && "border-b-black-sm"}`}
                                onClick={() => handleyearChange(item)}
                                key={item}
                            />
                        ))}
                    </div>

                    <CustomDropdown
                        options={dropDownData.filter((item: any) => item.name !== 'Average') || []} // Ensure data is not undefined
                        selectedValue={selectedDropDownDataLocation}
                        // onSelect={setSelectedDropDownData}
                        onSelect={handleChangeData}
                        labelKey="name" // Ensure `name` exists in data
                        valueKey="name"
                        classname="custom-dropdown height-4vh-custom"
                        style={{ minWidth: '20vh', maxWidth: 'fitContent' }}
                    />
                </div>
            </div>
            {/* <div style={{ height: '25.625rem', overflowY: 'auto', borderRadius: '0.814vh', borderColor: '#F4F4F4' }} className={'p-4 w-100 border d-flex align-items-center justify-content-center'}
            >
                <LineChartComponent
                    graphData={lineChartData}
                    selectedData={selectedDropDownDataLocation}
                    selectedDataIndex={selectedDataIndex}
                    setSelectedData={setSelectedDropDownDataLocation}
                    color={color}
                    headerText={headerText}
                    breakDownType={breakDownType}
                    selectedYear={selectedYear}
                    setSelectedDataIndex={setSelectedDataIndex} />
            </div> */}
            <div style={{ borderRadius: '0.814vh', borderColor: '#F4F4F4' }} className='w-100 border d-flex flex-column align-items-center justify-content-center'
            >
                <div className="p-4 w-100">
                    <LineChartComponent
                        graphData={lineChartData}
                        selectedData={selectedDropDownDataLocation}
                        selectedDataIndex={selectedDataIndex}
                        setSelectedData={setSelectedDropDownDataLocation}
                        color={color}
                        headerText={headerText}
                        breakDownType={breakDownType}
                        selectedYear={selectedYear}
                        setSelectedDataIndex={setSelectedDataIndex}
                    />
                </div>
                <div className="w-100 p-4 border-top d-flex flex-row justify-content-center align-items-center gap-3">
                    {lineChartData?.[selectedDataIndex]?.cagrText?.map((data: any) =>
                    (<div className='d-flex flex-row justify-content-center align-items-center gap-1'>
                        <span className='poi-circle bg-black-1' style={{ backgroundColor: `${data?.color}` }}></span>
                        <Heading
                            title={`${data?.label}`}
                            type={TypographyType.h5}
                            colour={TypographyColor.primary}
                        />
                    </div>))
                    }
                     {lineChartData?.[lineChartData?.length - 1]?.cagrText?.map((data: any) =>
                    (<div className='d-flex flex-row justify-content-center align-items-center gap-1'>
                        <span className='poi-circle bg-black-1' style={{ backgroundColor: `${data?.color}` }}></span>
                        <Heading
                            title={`${data?.label}`}
                            type={TypographyType.h5}
                            colour={TypographyColor.primary}
                        />
                    </div>))
                    }
                </div>
            </div>
        </div>
    );
};

